import React, { useState } from 'react'
import ListingLst from './listingLst'
import Pagination from '../../../common/pagination';

export default function ActiveListings({ type, items, handleDelete, listView }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(12);

    //get Current posts
    const indexOfLastPost = currentPage * itemsPerPage;
    const indexOfFirstPost = indexOfLastPost - itemsPerPage;
    const currentItems = items?.slice(indexOfFirstPost, indexOfLastPost);
    // const paginate = (pageNumber) => setCurrentPage(pageNumber);
    function paginate(pageNumber) {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 3)
    }
    return (
        <>
            <div id="active" class={type === 'active' ? "tab-pane fade a active in" : "tab-pane"}>
                <div className={listView == 'list' ? "dash_property_listing list_dash_property_listing" : "dash_property_listing grid_dash_property_listing"}>
                    {
                        currentItems !== undefined && currentItems !== '' && currentItems !== null && currentItems?.length > 0 ?
                            <>
                                {

                                    currentItems?.map((item, index) => {
                                        return (
                                            <ListingLst item={item} key={index} deleteItem={handleDelete} />
                                        )
                                    })
                                }

                            </>
                            :
                            <div className='alert alert-danger'>No listing(s) added yet!</div>
                    }

                </div>
                <Pagination paginate={paginate} itemsPerPage={itemsPerPage} totalItems={items?.length} currentPage={currentPage} />

            </div>
        </>
    )
}
